
export default class Accordion {
  constructor() {

    const acdHeads = document.querySelectorAll('.js-accordion');

    for (var i = 0; i < acdHeads.length; i++) {
      acdHeads[i].addEventListener('click', function () {
        var acdBody;
        // 同じ親要素を持つ隣接した次の要素を取得
        acdBody = this.nextElementSibling;
        acdBody.style.transition = 'height 0.5s ease-out';
        if (acdBody.style.height) {
          acdBody.style.height = acdBody.scrollHeight + 'px';
          this.classList.remove("isActive");
          setTimeout(function(){acdBody.style.height = null;},100);
        } else {
          acdBody.style.height = acdBody.scrollHeight + 'px';
          this.classList.add("isActive");
          setTimeout(function(){acdBody.style.height = 'auto';},600);
        }
      })
    }
  }
}
